module.exports = __webpack_public_path__ + "static/media/adesnitsky.36aacb93.jpg";